// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2N-s2","filesListContainer":"PosDisputesFiles_filesListContainer__2_FTt","filesButton":"PosDisputesFiles_filesButton__2U67M"};